// extracted by mini-css-extract-plugin
module.exports = {"url-input":"SparqlFetch_url-input__1OTEr","query-input-here":"SparqlFetch_query-input-here__1GTNa","base-iri-input-here":"SparqlFetch_base-iri-input-here__1MbOa"};